import { createContext } from "react";

const RolesContext = createContext();

export default RolesContext;
